module.exports = require("crypto");


//////////////////
// WEBPACK FOOTER
// external "crypto"
// module id = 12
// module chunks = 0